import React from 'react';
import { Box, Typography, keyframes } from '@mui/material';
import logo from './assets/Artemy.AI - Horizontal Logo-Trans.png';

const pulse = keyframes`
  0% { opacity: 0.6; transform: scale(0.98); }
  50% { opacity: 1; transform: scale(1); }
  100% { opacity: 0.6; transform: scale(0.98); }
`;

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const ArtemySplashScreen = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        backgroundColor: '#08090d',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      {/* Grid Background Effect */}
      <Box 
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'linear-gradient(rgba(61, 127, 255, .02) 1px, transparent 1px), linear-gradient(90deg, rgba(61, 127, 255, .02) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
          pointerEvents: 'none'
        }}
      />

      <Box 
        sx={{ 
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          animation: `${pulse} 3s ease-in-out infinite`
        }}
      >
        <img 
          src={logo} 
          alt="Artemy.AI" 
          style={{ 
            height: '60px', 
            marginBottom: '24px',
            filter: 'drop-shadow(0 0 15px rgba(61, 127, 255, 0.3))'
          }} 
        />
        
        <Box 
          sx={{
            width: '200px',
            height: '2px',
            backgroundColor: 'rgba(61, 127, 255, 0.1)',
            borderRadius: '2px',
            overflow: 'hidden',
            position: 'relative'
          }}
        >
          <Box 
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              width: '40%',
              backgroundColor: '#3d7fff',
              boxShadow: '0 0 8px #3d7fff',
              animation: `${shimmer} 2s infinite linear`
            }}
          />
        </Box>

        <Typography
          sx={{
            mt: 4,
            fontFamily: "'DM Mono', monospace",
            fontSize: '10px',
            color: '#4a5470',
            letterSpacing: '3px',
            textTransform: 'uppercase'
          }}
        >
          Initializing Secure Session
        </Typography>
      </Box>
    </Box>
  );
};

export default ArtemySplashScreen;
